'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _next = require('@alifd/next');

var _lodash = require('lodash');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _options = require('./options');

var _options2 = _interopRequireDefault(_options);

var _props2 = require('./props');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defaults(obj, defaults) { var keys = Object.getOwnPropertyNames(defaults); for (var i = 0; i < keys.length; i++) { var key = keys[i]; var value = Object.getOwnPropertyDescriptor(defaults, key); if (value && value.configurable && obj[key] === undefined) { Object.defineProperty(obj, key, value); } } return obj; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : _defaults(subClass, superClass); }

// 后端在大多数的场景中，都不会输出text，所以这边需要调整下
function formateValue(dataSource, value, multiple) {
  if (multiple && value && value.length > 0) {
    // 若value存在则取第一项为样本
    var sample = value[0];
    if (!sample.text) {
      return value.map(function (valueItem) {
        var idx = dataSource.findIndex(function (item) {
          return item.value === valueItem.value;
        });
        return idx > -1 ? dataSource[idx] : valueItem;
      });
    }

    // 当且仅当有value值 但是value没有text的内容
  } else if (!multiple && value && !value.text) {
    var idx = dataSource.findIndex(function (item) {
      return item.value === value.value;
    });
    if (idx > -1) {
      return dataSource[idx];
    }
  }
  return value;
}

var EnhanceSelect = function (_Component) {
  _inherits(EnhanceSelect, _Component);

  function EnhanceSelect(props, context) {
    _classCallCheck(this, EnhanceSelect);

    var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));

    _this.state = { visible: false };
    _this.forceReset = false;
    _this.handleVisibleChange = _this.handleVisibleChange.bind(_this);
    _this.handleSelectOnChange = _this.handleSelectOnChange.bind(_this);
    _this.handleOptionsOnChange = _this.handleOptionsOnChange.bind(_this);
    return _this;
  }

  EnhanceSelect.prototype.componentWillReceiveProps = function componentWillReceiveProps() {
    if (this.forceReset) {
      this.forceReset = false;
      // in custom overlay, when select item should clear the old value
      if (this.ins && this.ins._instance && this.ins._instance.clearValue) {
        this.ins._instance.clearValue();
      }
    }
  };

  EnhanceSelect.prototype.getCustomSelectProps = function getCustomSelectProps() {
    var _this2 = this;

    var customProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _Object$assign = _extends({}, this.props, customProps),
        loading = _Object$assign.loading,
        showSearch = _Object$assign.showSearch,
        lazyLoad = _Object$assign.lazyLoad,
        searchLocal = _Object$assign.searchLocal,
        threshold = _Object$assign.threshold,
        onBlur = _Object$assign.onBlur,
        onLoadMore = _Object$assign.onLoadMore,
        onSearchChange = _Object$assign.onSearchChange,
        notFoundContent = _Object$assign.notFoundContent,
        popupClassName = _Object$assign.popupClassName,
        valueRender = _Object$assign.valueRender,
        fillProps = _Object$assign.fillProps,
        others = _objectWithoutProperties(_Object$assign, ['loading', 'showSearch', 'lazyLoad', 'searchLocal', 'threshold', 'onBlur', 'onLoadMore', 'onSearchChange', 'notFoundContent', 'popupClassName', 'valueRender', 'fillProps']);

    var visible = this.state.visible;
    var value = others.value,
        dataSource = others.dataSource,
        multiple = others.multiple,
        disabled = others.disabled,
        placeholder = others.placeholder,
        hasClear = others.hasClear,
        useDetailValue = others.useDetailValue,
        autoWidth = others.autoWidth,
        style = others.style,
        className = others.className,
        size = others.size;


    var popupContent = _react2.default.createElement(
      _options2.default,
      {
        visible: visible,
        multiple: multiple,
        showSearch: showSearch,
        lazyLoad: lazyLoad,
        loading: loading,
        searchLocal: searchLocal,
        notFoundContent: notFoundContent,
        value: value,
        dataSource: dataSource,
        onLoadMore: onLoadMore,
        onSearchChange: onSearchChange,
        useDetailValue: useDetailValue,
        onChange: this.handleOptionsOnChange
      },
      _react2.default.createElement(
        'div',
        null,
        '\xA0'
      )
    );
    return {
      dataSource: dataSource,
      useDetailValue: useDetailValue,
      notFoundContent: notFoundContent,
      autoWidth: autoWidth,
      multiple: multiple,
      hasClear: hasClear,
      visible: visible,
      disabled: disabled,
      style: style,
      className: className,
      popupClassName: popupClassName,
      valueRender: valueRender,
      fillProps: fillProps,
      // 对于弹框不显示的场景下。如果resize会触发react-list内部的计算函数，由于不显示导致计算高度错误的问题
      popupContent: visible ? popupContent : _react2.default.createElement(
        'div',
        null,
        '\xA0'
      ),
      ref: function ref(node) {
        _this2.ins = node;
      },
      // value: formateValue(dataSource, value, multiple),
      value: value,
      placeholder: disabled ? ' ' : placeholder,
      onVisibleChange: this.handleVisibleChange,
      onChange: this.handleSelectOnChange,
      onBlur: onBlur,
      size: size
    };
  };

  EnhanceSelect.prototype.handleVisibleChange = function handleVisibleChange(visible) {
    var _this3 = this;

    this.setState({ visible: visible }, function () {
      _this3.props.onVisibleChange(visible);
    });
  };

  // only trigger when delete in select input.


  EnhanceSelect.prototype.handleSelectOnChange = function handleSelectOnChange(value) {
    this.props.onChange(value);
  };

  EnhanceSelect.prototype.handleOptionsOnChange = function handleOptionsOnChange(value) {
    // when click the selected item, value will be set null, ignore this case
    if ((0, _lodash.isNil)(value)) {
      this.handleVisibleChange(false);
      return;
    }
    var _props = this.props,
        onChange = _props.onChange,
        multiple = _props.multiple;

    this.forceReset = true;
    // auto close select panel when single select
    if (!multiple) {
      this.setState({ visible: false }, function () {
        onChange(value);
      });
    } else {
      onChange(value);
    }
  };

  EnhanceSelect.prototype.render = function render() {
    var _getCustomSelectProps = this.getCustomSelectProps(),
        className = _getCustomSelectProps.className,
        multiple = _getCustomSelectProps.multiple,
        popupClassName = _getCustomSelectProps.popupClassName,
        fillProps = _getCustomSelectProps.fillProps,
        others = _objectWithoutProperties(_getCustomSelectProps, ['className', 'multiple', 'popupClassName', 'fillProps']);

    return _react2.default.createElement(_next.Select, _extends({}, others, {
      fillProps: fillProps,
      popupClassName: popupClassName,
      mode: multiple ? 'multiple' : 'single',
      className: (0, _classnames2.default)('sell-o-select', className)
    }));
  };

  return EnhanceSelect;
}(_react.Component);

exports.default = EnhanceSelect;


EnhanceSelect.displayName = 'EnhanceSelect';
EnhanceSelect.propTypes = _extends({}, _props2.propTypes, {
  disabled: _propTypes2.default.bool,
  placeholder: _propTypes2.default.string,
  onVisibleChange: _propTypes2.default.func
});
EnhanceSelect.defaultProps = _extends({}, _props2.defaultProps, {
  disabled: false,
  placeholder: '',
  fillProps: 'text',
  onVisibleChange: function onVisibleChange() {}
});
module.exports = exports['default'];